import React from 'react';
import TextField from '@material-ui/core/TextField';
import Autocomplete, { createFilterOptions } from '@material-ui/lab/Autocomplete';
const filter = createFilterOptions();

export default function EmbeddedAnnotationSelect(props) {
    return (
        <Autocomplete
            onChange={(event, newValue) => {
                    console.log(event)
                    // when a previously existing selection is made/cancelled
                    if (newValue && newValue.count) {
                        
                        props.attachAnnotationButton(newValue)
                    }
            }}
            filterOptions={(options, params) => {
                const filtered = filter(options, params); 
                return filtered;
            }}
            // autoSelect
            selectOnFocus
            clearOnBlur
            handleHomeEndKeys
            defaultValue={"Make a selection"}
            id="free-solo-with-text-demo"
            options={props.annotations}
            getOptionLabel={(option) => {
                // Value selected with enter, right from the input
                if (typeof option === 'string') {
                    return option;
                }
                // Regular option
                return option.state.name;
            }}
            renderOption={(option) =>  option.state.name}
            size={'small'}
            style={{ width: "100%"}}
            freeSolo
            renderInput={(params) => (
                <div className="flex-centered">
                    <TextField {...params } label="Please select an annotation from the list"/>
                </div>
            )}
        />
    );
}